
// import { lang } from '~/data-utils';
import { getClosest } from '~/map/vg/vg-utils';
import SearchItem from '~/search/search-item';
import Facility from './facility-item';
import { getTypeTags } from './facility-tags';
import { idToType } from './facility-types';


export default class VGFacilitiesProvider {

  constructor (mapviewer, imdHash) {
    this.mapviewer = mapviewer;
    this.imdHash = imdHash;
    const pois = mapviewer.getPOIs();
    this.facilitiesMap = new Map();
    this.facilitySearchItemMap = new Map(
      VGFacilitiesProvider.facilityPOIs(pois)
    );
    // console.log(this.facilitySearchItemMap);
    this.searchItems = Array.from(this.facilitySearchItemMap.values());
    this.types = VGFacilitiesProvider.getTypes(pois);
    // console.log(this.types);
    this.closest = this._getClosestByTypes();
  }

  getClosest () {
    return this.closest;
  }

  getFacility (id) {
    if (!this.facilitiesMap.has(id)) {
      // const loc = getLocalized(this.mapviewer.getExtraData(), lang());
      // console.log(loc, lang());
      // const { venueLayout } = loc;
      const searchItem = this.facilitySearchItemMap.get(id);
      // Will happen if facility type is not mapped
      if (!searchItem) return null;

      const { url, floor } = searchItem.ref.vg.options();

      const facility = Facility.of({
        type: searchItem.ref.type,
        id,
        icon: url,
        floor: floor
      });
      this.facilitiesMap.set(id, facility);

    }
    return this.facilitiesMap.get(id);
  }

  static facilityPOIs (pois) {
    return Object.entries(pois).reduce((acc, [id, [vg]]) => {
      const type = idToType(id);
      if (type) {
        return acc.concat(
          // Double array to keep acc as 2D Array
          [[id, SearchItem.of(
            {
              id,
              type: 'facility',
              primary: getTypeTags(type),
              secondary: [],
              ref: {
                vg,
                type
              }
            }
          )]]
        );
      }
      return acc;
    }, []);
  }

  static getTypes (pois) {
    const keys = Object.keys(pois);
    const set = keys.reduce((acc, id) => {
      const type = idToType(id);
      type && acc.add(type);
      return acc;
    }, new Set());
    return Array.from(set);
  }

  async _getClosestByTypes () {
    // No kiosk POI means nothing to route from (VGMiddleware logs the missing IMD)
    if (!this.mapviewer.getPOI(this.imdHash)) return [];

    const results = await Promise.all(
      this.types.map(async type => {
        try {
          const id = await this._getClosestByType(type);
          const item = this.facilitySearchItemMap.get(id);
          return item;
        } catch (e) {
          console.error(e);
          return null;
        }
      })
    );

    return results.filter(x => x);
  }

  // _getClosestByType :: String -> Promise facility_id
  _getClosestByType (type) {

    const { mapviewer, imdHash } = this;

    const ids = this.searchItems.reduce((acc, x) => {
      return x.ref.type == type ? acc.concat(x.id) : acc;
    }, []);

    return getClosest(ids, {
      mapviewer,
      options: { imdHash }
    });
  }


}
